var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/Play_rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 14 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7ZM7 4C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4H7Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.77375C8 7.79426 10.1429 6.55709 11.8571 7.54683L15.7143 9.77375C17.4286 10.7635 17.4286 13.2379 15.7143 14.2276L11.8571 16.4545C10.1429 17.4443 8 16.2071 8 14.2276L8 9.77375ZM14.4286 12.0007L10.5714 9.77375L10.5714 14.2276L14.4286 12.0007Z",
    fill: "#667085",
    stroke: "white",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningCenter);
export default __webpack_public_path__ + "static/media/learningCenter.1e101e3caa65fd062e812045a995d9df.svg";
export { ForwardRef as ReactComponent };